var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-type-selection",on:{"click":_vm.selectListType}},[_c('div',{staticClass:"line mr-2"}),_c('span',{staticClass:"list-type-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("icon"),_c('div',{staticClass:"line ml-2"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }